import { render, staticRenderFns } from "./ancillaries.vue?vue&type=template&id=48db223a&scoped=true"
import script from "./ancillaries.vue?vue&type=script&lang=js"
export * from "./ancillaries.vue?vue&type=script&lang=js"
import style0 from "./ancillaries.vue?vue&type=style&index=0&id=48db223a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48db223a",
  null
  
)

export default component.exports